(function () {
    var version = '2.29.4';

    function interceptor($cookies) {
        return {
            request: function (config) {
                if ($cookies.get('_user_email_') !== undefined) {
                    config.headers['Authorization'] = $cookies.get('_user_email_') + ':' + $cookies.get('_user_password_');
                }
                return config;
            }
        }
    }

    function setMetaTags(meta, description) {
        var title = document.getElementsByTagName("meta");
        if (title) {
            for (var i = 0; i < title.length; i++) {
                if (title[i].getAttribute("name") === "title") {
                    meta = meta.split('+').join(' ');
                    title[i].setAttribute("content", meta);
                } else if (title[i].getAttribute("name") === "description") {
                    description = description.split('+').join(' ');
                    title[i].setAttribute("content", description)
                }
            }

        }
    }

    function readCookie(name) {
        var cookiename = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(cookiename) == 0) return c.substring(cookiename.length, c.length);
        }
        return null;
    }


    'use strict';
    angular
        .module('app',
            [
                'ui.router',
                'ngCookies',
                'authenticator',
                'dialog',
                'ui.select',
                'ui.mask',
                'ui.bootstrap',
                'ngSanitize',
                'ui.validate',
                'uiCropper',
                'pascalprecht.translate'
            ])
        .filter('formatCurrency', function () {
            return function (input, currencyCode) {
                if (!(typeof currencyCode === 'string' || currencyCode instanceof String)) {
                    return input;
                }
                currencyCode = currencyCode.toUpperCase();
                if (!Number.isInteger(input)) {
                    input = parseFloat(input).toFixed(2);
                }
                if (currencyCode === 'USD') {
                    return '$' + input;
                }
                if (currencyCode === 'GBP') {
                    return '£' + input;
                }
                if (currencyCode === 'EUR') {
                    return '€' + input;
                }
                return input + ' ' + currencyCode;
            }
        })
        .filter('groupBy', function () {
            return function (list, group_by) {

                var filtered = [];
                var prev_item = null;
                var group_changed = false;
                // this is a new field which is added to each item where we append "_CHANGED"
                // to indicate a field change in the list
                var new_field = group_by + '_CHANGED';

                // loop through each item in the list
                angular.forEach(list, function (item) {

                    group_changed = false;

                    // if not the first item
                    if (prev_item !== null) {

                        // check if the group by field changed
                        if (prev_item[group_by] !== item[group_by]) {
                            group_changed = true;
                        }

                        // otherwise we have the first item in the list which is new
                    } else {
                        group_changed = true;
                    }

                    // if the group changed, then add a new field to the item
                    // to indicate this
                    if (group_changed) {
                        item[new_field] = true;
                    } else {
                        item[new_field] = false;
                    }

                    filtered.push(item);
                    prev_item = item;

                });

                return filtered;
            };
        })
        .filter('maybePreFixUrl', function () {
            return function (url) {
                if (typeof url === 'string' || url instanceof String) {
                    if (!url.startsWith('http') && !url.startsWith('//')) {
                        return 'http://' + url;
                    }
                }

                return url;
            }
        })
        .filter('number_format', function ($cookies, $filter, $locale) {
            return function (number, decimals) {
                if (isNaN(number)) return 0;
                var lang = $cookies.get('selected_language');
                if (lang == 'da_dk') {
                    $locale.NUMBER_FORMATS.GROUP_SEP = '.';
                    $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
                    return $filter('number')(number, (decimals != undefined) ? decimals : '2');
                }
                return $filter('number')(number, (decimals != undefined) ? decimals : '2');
            }
        })
        .directive('jsonld', ['$filter', '$sce', function ($filter, $sce) {
            return {
                restrict: 'E',
                template: function () {
                    return '<script type="application/ld+json" ng-bind-html="onGetJson()"></script>';
                },
                scope: {
                    json: '=json'
                },
                link: function (scope, element, attrs) {
                    scope.onGetJson = function () {
                        return $sce.trustAsHtml($filter('json')(scope.json));
                    }
                },
                replace: true
            };
        }])
        .filter('preg_replace', function () {
            return function (input, regex, replace_with) {
                if (replace_with === undefined) {
                    replace_with = '';
                }
                if (input !== undefined) {
                    return input.replace(new RegExp(regex), replace_with);
                }
            }
        })
        .filter('formatDate', function () {
            return function (input, format) {
                return moment(input).format(format);
            }
        })
        .filter('trust', ['$sce', function ($sce) {
            return function (value, type) {
                return $sce.trustAs('html', value.toString());
            }
        }])
        .config(function (uiSelectConfig, $provide) {
            uiSelectConfig.theme = 'bootstrap';

            $provide.decorator('$state', function ($delegate, $transitions) {
                $transitions.onStart({}, function (trans) {
                    $delegate.toParams = trans.params();
                    $delegate.toName = trans.to().name;
                });
                return $delegate
            });
        })
        .config(["$translateProvider", function ($translateProvider) {


            //$translateProvider.useUrlLoader("app/api/translations.php");

            $translateProvider.useStaticFilesLoader({
                prefix: 'locales/locale-',
                suffix: '.json?v' + version
            });
            $translateProvider.preferredLanguage('en');

            $translateProvider.registerAvailableLanguageKeys(['en', 'da', 'sv'], {
                'en_US': 'en',
                'en_UK': 'en',
                'da_DK': 'da',
                'se_SE': 'sv',
                'sv': 'sv',
                '*': 'en'
            });

            $translateProvider.preferredLanguage('da');
            $translateProvider.fallbackLanguage('en');
            $translateProvider.useLoaderCache(false);
            $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        }])
        .factory('interceptor', interceptor)
        .config(function ($httpProvider) {
            $httpProvider.interceptors.push('interceptor');
        })
        .constant('LOWFI_APP_DEBUG', !!window.LOWFI_APP_DEBUG)
        .config(['$logProvider', function($logProvider) {
          $logProvider.debugEnabled(!!window.LOWFI_APP_DEBUG);
        }])
        .run(function ($transitions, $rootScope, $location, $window, $q, $cookies) {
            // set the base uiDateConfig on the $rootScope on startup
            $rootScope.uiDateConfig = {
                initDate: new Date(),
                maxMode: 'day',
                format: 'dd.MM.yyyy'
            };

            window.onbeforeunload = function () {
                sessionStorage.clear();
            };

            // moment config
            moment.updateLocale('en', {
                week: {
                    dow: 1, // Monday is the first day of the week.
                    doy: 4  // Used to determine first week of the year.
                }
            });

            const lang = $cookies.get('selected_language');
            if (lang === 'da_dk') {
                moment.locale('da');
            } else if (lang === 'sv') {
                moment.locale('sv');
            }

            $rootScope.fb_initialized = $q.defer();
            $rootScope.meta = readCookie('meta');
            $rootScope.description = readCookie('description');

            // Facebook login async info
            $window.fbAsyncInit = function () {
                FB.init({
                    appId: FB_APP_ID,
                    cookie: true,
                    status: true,
                    xfbml: true,
                    oauth: true,
                    version: FB_GRAPH_VERSION
                });

                $rootScope.FB = FB;
                $rootScope.fb_initialized.resolve(true);
            };

            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));


            $transitions.onSuccess({}, function (trans) {
                var identifier = (typeof trans._targetState._identifier === 'string' ? trans._targetState._identifier : trans._targetState._identifier.name);

                // TODO Figure out something proper for meta tags
                /* $rootScope.meta = readCookie('meta');
                $rootScope.description = readCookie('description');
                setMetaTags($rootScope.meta, $rootScope.description); */

                switch (identifier) {
                    case 'sign_up':
                    case 'login':
                    case 'forgotten_password':
                    case 'stripe_connect':
                    case 'band_preview':
                    case 'space_preview':
                    case 'concert_preview':
                    case 'review':
                    case 'reset_password':
                        // Ignore these views, i.e. don't add them as a previous state.
                        // This usually means that these states are regarded as popup-like in the application, and should themselves be able to resolve back to a previous state and therefore should be part of the previous state chain
                        break;
                    default:
                        // sets the previous state to enable popup views to return to previous state
                        $rootScope.previousState = {
                            name: identifier,
                            params: trans._targetState._params
                        };
                        break;
                }

                // initiate and config Google Tag Manager (Analytics)
                window.dataLayer = window.dataLayer || [];

                // ga('create', 'UA-116201197-1', 'auto');

                function gtag() {
                    dataLayer.push(arguments);
                }

                gtag('js', new Date());

                // //Google Analytics pageview:
                // gtag('config', 'UA-116201197-1', {
                //     'page_title': identifier,
                //     'page_path': $location.$$path
                // });

            });
        });
})();
